"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percent = void 0;
function percent(percent, num) {
    return (percent / 100) * num;
}
exports.percent = percent;
//# sourceMappingURL=percent.js.map